import { NotificationPermissionBanner } from '@/core/notification/permission-banner';
import { useFcmRegistration } from '@/core/notification/use-fcm-registration';
import { useSignalRReconnector } from '@/core/realtime/hooks/use-signalr-reconnector';
import { useSocketEventHandlers } from '@/core/realtime/hooks/use-socket-handlers';
import { useAuthStore } from '@/features/auth';
import { useConversationSubscription } from '@/features/conversation';
import { Outlet, createRootRoute } from '@tanstack/react-router';
import { useEffect } from 'react';

export const Route = createRootRoute({
  component: RootComponent
});

function RootComponent() {
  // const router = useRouter();

  // Socket actions
  useSignalRReconnector();
  useSocketEventHandlers();
  useConversationSubscription();

  // Register FCM after login
  useFcmRegistration();

  useEffect(() => {
    useAuthStore.getState().load();
  }, []);

  return (
    <>
      <Outlet />
      {/* {!router.history.location.pathname.includes('/chat') && <Bubble />} */}
      <NotificationPermissionBanner />
    </>
  );
}
